module.exports = __webpack_public_path__ + "img/b67e835.png";